import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class TicketService {
  participantsList: string[] = []

  constructor(private readonly http: HttpClient) {
  }

  private get ticketAPI(): string {
    const domain = sessionStorage.getItem('Domain');
    if (domain === 'L') {
      return environment.liveURL;
    } else {
      return environment.ticketAPI;
    }
  }

  getTicketsCount(status: string): Observable<any> {
    const email = sessionStorage.getItem('emailAddress');
    const authToken = sessionStorage.getItem('auth_token');
    const encryptedEmail = sessionStorage.getItem('ecryptedEMail');

    if (!email || !authToken || !encryptedEmail) {
      console.error('[TicketService] Session expired or missing required session data.');
      throw new Error('Session expired or missing required session data. Please log in again.');
    }
    return this.http.post(
      `${this.ticketAPI}/ticket/`,
      {
        "email": email,
        "status": `${status}`
      },
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${authToken}`,
          'X-Frame-edi': encryptedEmail
        }),
      }
    )
  }

  getTicketsData(status: string, page_size: number): Observable<any> {
    const email = sessionStorage.getItem('emailAddress');
    const authToken = sessionStorage.getItem('auth_token');
    const encryptedEmail = sessionStorage.getItem('ecryptedEMail');

    if (!email || !authToken || !encryptedEmail) {
      console.error('[TicketService] Session expired or missing required session data.');
      throw new Error('Session expired or missing required session data. Please log in again.');
    }

    const params = new HttpParams().set('page_size', page_size);

    return this.http.post(
      `${this.ticketAPI}/ticket/`,
      {
        "email": email,
        "status": `${status}`
      },
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${authToken}`,
          'X-Frame-edi': encryptedEmail
        }),
        params: params
      }
    )
  }

  nextTicketData(url: string, status: string): Observable<any> {
    const email = sessionStorage.getItem('emailAddress');
    const authToken = sessionStorage.getItem('auth_token');
    const encryptedEmail = sessionStorage.getItem('ecryptedEMail');

    if (!email || !authToken || !encryptedEmail) {
      console.error('[TicketService] Session expired or missing required session data.');
      throw new Error('Session expired or missing required session data. Please log in again.');
    }

    return this.http.post(
      url,
      {
        "email": email,
        "status": `${status}`
      },
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${authToken}`,
          'X-Frame-edi': encryptedEmail
        }),
      }
    )
  }

  nextTicketDataSort(url: string, filter: string, order: string):Observable<any>  {
    const email = sessionStorage.getItem('emailAddress');
    const authToken = sessionStorage.getItem('auth_token');
    const encryptedEmail = sessionStorage.getItem('ecryptedEMail');

    if (!email || !authToken || !encryptedEmail) {
      console.error('[TicketService] Session expired or missing required session data.');
      throw new Error('Session expired or missing required session data. Please log in again.');
    }

    return this.http.post(
      url,
      {
        "email": email,
        "filter": `${filter}`,
        "sort_by": `${order}`
      },
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${authToken}`,
          'X-Frame-edi': encryptedEmail
        }),
      }
    ) 
  }

  sortTicketsData(filter: string, order: string, page_size: number): Observable<any> {
    const email = sessionStorage.getItem('emailAddress');
    const authToken = sessionStorage.getItem('auth_token');
    const encryptedEmail = sessionStorage.getItem('ecryptedEMail');

    if (!email || !authToken || !encryptedEmail) {
      console.error('[TicketService] Session expired or missing required session data.');
      throw new Error('Session expired or missing required session data. Please log in again.');
    }

    const params = new HttpParams().set('page_size', page_size);

    return this.http.post(
      `${this.ticketAPI}/ticket/sort/`,
      {
        "email": email,
        "filter": `${filter}`,
        "sort_by": `${order}`
      },
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${authToken}`,
          'X-Frame-edi': encryptedEmail
        }),
        params: params
      }
    )
  }

  getTicketDetails(ticket_id: string): Observable<any> {
    const authToken = sessionStorage.getItem('auth_token');
    if (!authToken) {
      console.error('[TicketService] Session expired or missing required session data.');
      throw new Error('Session expired or missing required session data. Please log in again.');
    }

    return this.http.post(
      `${this.ticketAPI}/ticket/details/`,
      {
        "ticket_id": `${ticket_id}`
      },
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${authToken}`
        })
      }
    )
  }

  replyOnTicket(ticket_id: string, email_body: string, attachment_list: File[]): Observable<any> {

    let updatedHtml = email_body.replace(
      /<img[^>]+src=["']blob:http[^"']+["'][^>]*>/gi,
      match => match.replace('<img', '<img class="display-none"')
    );

     // Then, show uploaded images from the blob storage and remove display: none
    updatedHtml = updatedHtml.replace(
      /<img([^>]*src=["']https:\/\/trplprodhelpdesk\.blob\.core\.windows\.net\/static[^"']+["'][^>]*)>/gi,
      (_, imgAttributes) => {
        // Remove display: none !important; from style attribute
        const updatedAttributes = imgAttributes.replace(/display:\s*none\s*!important;\s*/gi, '');
        return `<img${updatedAttributes}>`;
      }
    );

    console.log(updatedHtml)


    const email = sessionStorage.getItem('emailAddress');
    const authToken = sessionStorage.getItem('auth_token');

    if (!email || !authToken) {
      console.error('[TicketService] Session expired or missing required session data.');
      throw new Error('Session expired or missing required session data. Please log in again.');
    }

    const formData = new FormData()
    formData.append('email', email)
    formData.append('cc_list', JSON.stringify(this.participantsList))
    formData.append('email_body', updatedHtml)
    formData.append('ticket_id', ticket_id)
    for (const file of attachment_list) {
      formData.append('attachment_list', file, file.name);
    }

    return this.http.post(
      `${this.ticketAPI}/ticket/reply/`,
      formData,
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${authToken}`
        })
      }
    )
  }

  createTicket(email_subject: string, cc_list: string[], email_body: string, attachment_list: File[]): Observable<any> {

    const email = sessionStorage.getItem('emailAddress');
    const authToken = sessionStorage.getItem('auth_token');

    let updatedHtml = email_body.replace(
      /<img[^>]+src=["']blob:http[^"']+["'][^>]*>/gi,
      match => match.replace('<img', '<img class="display-none"')
    );

    updatedHtml = updatedHtml.replace(
      /<img([^>]*src=["']https:\/\/trplprodhelpdesk\.blob\.core\.windows\.net\/static[^"']+["'][^>]*)>/gi,
      (_, imgAttributes) => {
        const updatedAttributes = imgAttributes.replace(/display:\s*none\s*!important;\s*/gi, '');
        return `<img${updatedAttributes}>`;
      }
    );

    console.log(updatedHtml)


    if (!email || !authToken) {
      console.error('[TicketService] Session expired or missing required session data.');
      throw new Error('Session expired or missing required session data. Please log in again.');
    }

    const formData = new FormData()
    formData.append('email', email)
    formData.append('email_subject', email_subject)
    formData.append('cc_list', JSON.stringify(cc_list))
    formData.append('email_body', updatedHtml);
    formData.append('portal_flag', '1')
    for (const file of attachment_list) {
      formData.append('attachment_list', file, file.name);
    }

    return this.http.post(
      `${this.ticketAPI}/ticket/create/`,
      formData,
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${authToken}`
        })
      }
    )
  }

  searchTicket(searchString: string): Observable<any> {
    const email = sessionStorage.getItem('emailAddress');
    const authToken = sessionStorage.getItem('auth_token');
    const encryptedEmail = sessionStorage.getItem('ecryptedEMail');

    if (!email || !authToken || !encryptedEmail) {
      console.error('[TicketService] Session expired or missing required session data.');
      throw new Error('Session expired or missing required session data. Please log in again.');
    }

    let body: any = {
      "email": email,
    };

    if (/^\d+$/.test(searchString)) {
      body["ticket_id"] = parseInt(searchString, 10);
    } else {
      body["subject"] = searchString;
    }

    return this.http.post(
      `${this.ticketAPI}/ticket/search/`,
      body,
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${authToken}`,
          'X-Frame-edi': encryptedEmail
        })
      }
    )
  }

  reopenTicket(ticketID: string): Observable<any> {
    const authToken = sessionStorage.getItem('auth_token');
    if (!authToken) {
      console.error('[TicketService] Session expired or missing required session data.');
      throw new Error('Session expired or missing required session data. Please log in again.');
    }

    const formData = new FormData()

    formData.append('ticket_id', ticketID)

    return this.http.post(
      `${this.ticketAPI}/ticket/reopen/`,
      formData,
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${authToken}`
        })
      }
    )
  }

}
